<strong class="hideInResponsive">{{ greetingLanguageLabel }},</strong>&nbsp;{{userObject?.userFirstName}}!

